<template>
	<Modal v-model="modal3.ifShow" :title="modal3.Title" width="30%" :mask-closable="false" :closable="false">
		<!--充值-->
		<Form label-position="right" :rules="ruleInline3" ref="RechargeForCardForm" :model="RechargeForCardInfo"
			:label-width="110">
			<Row :gutter="24">
				<Col span=24>
				<FormItem :label="$tt('会员ID:')" prop="Id">
					<Input :disabled="modal3.canInput" v-model="RechargeForCardInfo.Id" :placeholder="$tt('输入会员ID')"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="24">
				<Col span=12>
				<FormItem :label="$tt('充值金额:')" prop="RechargeAccount">
					<Input v-model="RechargeForCardInfo.RechargeAccount" :placeholder="$tt('充值金额')" number></Input>
				</FormItem>
				</Col>
				<Col span=12>
				<FormItem :label="$tt('赠送金额')" prop="GivenAccount">
					<Input v-model="RechargeForCardInfo.GivenAccount" :placeholder="$tt('赠送金额')" number></Input>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<div v-if="modal3.type=='add'" slot="footer">
			<Button type="warning" size="large" @click="modalOk3('cancle')">{{$tt('取消')}}</Button>
			<Button type="success" size="large" @click="modalOk3('add')">{{$tt('充值')}}</Button>
		</div>
	</Modal>
</template>

<script>
	import webapi from '../../../../webapi'
	export default {
		data() {
			return {
				//充值model属性
				RechargeForCardInfo: {
					Id: '',
					RechargeAccount: 0,
					GivenAccount: 0,
				},
				//model2 充值
				modal3: {
					Title: this.$tt('个人会员电卡充值'),
					type: "add",
					ifShow: false,
					canInput: true
				},
				//充值model 规则
				ruleInline3: {
					RechargeAccount: [{
							required: true,
							message: this.$tt('请输入价格'),
							trigger: 'blur',
							type: 'number',
						},
						// {
						// 	validator: usernameV,
						// 	trigger: 'blur'
						// }
					],
					GivenAccount: [{
						required: true,
						message: this.$tt('请输入价格'),
						trigger: 'blur',
						type: 'number',
					}]
				},
			}
		},
		methods: {
			//打开个人电卡充值
			openRechargeForCard: function(Id, CardNo) {
				this.$refs.RechargeForCardForm.resetFields()
				this.RechargeForCardInfo.Id = Id
				this.modal3.ifShow = true
			},
			//个人会员电卡充值
			RechargeForCard: function() {
				const _this = this;
				let parms = _this.RechargeForCardInfo;
				_this.$refs.RechargeForCardForm.validate((valid) => {
					if (valid) {
						_this.$axios.post(webapi.base_api_url + "/Member/RechangeForGroupMember", parms, {})
							.then(res => {
								console.log("个人会员电卡充值")
								console.log(res.data)
								if (res.data.Code == 0) {
									_this.$Message.success(this.$tt('个人会员电卡充值成功'));
									_this.$emit("upData")
									this.modal3.ifShow = false
								} else {
									_this.$Message.success(this.$tt('个人会员电卡充值失败'));
									_this.$Message.success(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
			//model3操作
			modalOk3: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal3.ifShow = false
						break;
					case 'add':
						_this.modal3.ifShow = true
						_this.RechargeForCard();
						break;
					default:
						break;
				}
			},
		}
	}
</script>

<style>
</style>
